'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.monitor.list', [])
  .controller('MonitorListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/monitor/list/index.js